import { render, staticRenderFns } from "./ExtendInfo.vue?vue&type=template&id=ee2956f8&scoped=true"
import script from "./ExtendInfo.vue?vue&type=script&lang=js"
export * from "./ExtendInfo.vue?vue&type=script&lang=js"
import style0 from "./ExtendInfo.vue?vue&type=style&index=0&id=ee2956f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee2956f8",
  null
  
)

export default component.exports